// extracted by mini-css-extract-plugin
module.exports = {"container":"PostAction_container__M-C0R"};